<template>
  <div>
    <div v-if="hasVideo !== ''" class="product-media-video">
      <div class="product-video">
        <video autoplay playsinline loop muted>
          <source :src="hasVideo" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
      </div>
    </div>
    <div v-else>
      <img
        v-lazy="imgObj"
        :alt="alt"
        :title="alt"
        :key="imgObj.src"
        :style="styleImage"
      />
    </div>
  </div>
</template>

<script>
import { getThumbnailPath } from '@/helpers'
import defaultDump from 'theme/assets/image/dump.png'

export default {
  props: {
    imgPath: {
      type: String,
      default: ''
    },
    hasVideo: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    styleImage: {
      type: Object,
      default () { return {} }
    },
    alt: {
      type: String,
      default: 'Image'
    },
    changeAble: {
      type: Boolean,
      default: () => false
    },
    defaultLoading: {
      default: () => defaultDump
    }
  },
  computed: {
    imgObj () {
      let placeholder = this.defaultLoading
      let imageOject = {
        src: getThumbnailPath(this.imgPath, this.size),
        error: placeholder,
        loading: placeholder
      }
      return imageOject
    }
  }
}
</script>
